import { render, staticRenderFns } from "./secao-04-membros-familiares.vue?vue&type=template&id=7ec5a25f&scoped=true"
import script from "./secao-04-membros-familiares.vue?vue&type=script&lang=js"
export * from "./secao-04-membros-familiares.vue?vue&type=script&lang=js"
import style0 from "./secao-04-membros-familiares.vue?vue&type=style&index=0&id=7ec5a25f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec5a25f",
  null
  
)

export default component.exports